import React, { FC, useMemo } from "react";
import { Card } from "antd";
import { SquarePen } from "lucide-react";
import { Icon } from "src/components/icons/Icon";
import { useFileManagement } from "src/hooks/useFileManagement";
import { useHistory } from "react-router-dom";
import impirica_logo from "src/assets/images/Impirica Logo Square.png";
import styles from "./CourseCard.module.scss";
import Meta from "antd/lib/card/Meta";

interface IProps {
	id: number;
	img?: string;
	title?: string;
	description?: string;
}

const CourseCard: FC<IProps> = ({ id, img, title, description }) => {
	const { getFileUrl } = useFileManagement();
	const { push } = useHistory();

	const thumbnailUrl = img ? getFileUrl(img) : null;

	const onEdit = () => {
		push(`/admin/training/${id}`);
	};

	return (
		<Card
			hoverable
			className={styles.card}
			onClick={onEdit}
			cover={
				<img
					className={styles.image}
					alt="logo"
					src={thumbnailUrl || impirica_logo}
				/>
			}
			actions={[
				<span key="edit">
					Edit Course
					<Icon className={styles.actionIcon} icon={SquarePen} />
				</span>,
			]}
		>
			<Meta
				title={title}
				description={
					<div className={styles.truncate}>
						<div className={styles.description} title={description}>
							{description || "No description"}
						</div>
					</div>
				}
			/>
		</Card>
	);
};

export default CourseCard;
